// sendAppCommand('openVideo', {url: 'https://shop_bluewaters.fw.tv/?fw_video=5LDmO6&fw_channel=shop_bluewaters'})
// sendAppCommand('navigateToCollection', {collectionId: 'gid://shopify/Collection/276849066026', title: 'New Arrivals'})
// sendAppCommand('navigateToProduct', {productId: 'gid://shopify/Product/7061162098730'})
// sendAppCommand('navigateTo', {pathname: '/live'})
// sendAppCommand('navigateTo', {pathname: '/replay'})

function sendAppCommand(command, params) {
  window.ReactNativeWebView.postMessage(JSON.stringify({ command, params }));
}
